"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var React = require("react");
var elements_1 = require("../diagram/elements");
var events_1 = require("../viewUtils/events");
var geometry_1 = require("../diagram/geometry");
var WIDTH = 300;
var HEIGHT = 300;
var ELEMENT_OFFSET = 40;
var LINK_OFFSET = 20;
var FOCUS_OFFSET = 20;
var Dialog = /** @class */ (function (_super) {
    tslib_1.__extends(Dialog, _super);
    function Dialog() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.unsubscribeFromTarget = undefined;
        _this.handler = new events_1.EventObserver();
        _this.updateAll = function () { return _this.forceUpdate(); };
        return _this;
    }
    Dialog.prototype.componentDidMount = function () {
        this.listenToTarget(this.props.target);
        this.focusOn();
    };
    Dialog.prototype.componentWillReceiveProps = function (nextProps) {
        if (nextProps.target !== this.props.target) {
            this.listenToTarget(nextProps.target);
        }
    };
    Dialog.prototype.componentWillUnmount = function () {
        this.listenToTarget(undefined);
    };
    Dialog.prototype.listenToTarget = function (target) {
        var _this = this;
        if (this.unsubscribeFromTarget) {
            this.unsubscribeFromTarget();
            this.unsubscribeFromTarget = undefined;
        }
        if (target) {
            var view = this.props.view;
            if (target instanceof elements_1.Element) {
                this.listenToElement(target);
            }
            else if (target instanceof elements_1.Link) {
                this.listenToLink(target);
            }
            this.handler.listen(view.events, 'changeLanguage', this.updateAll);
            this.unsubscribeFromTarget = function () { _this.handler.stopListening(); };
        }
    };
    Dialog.prototype.listenToElement = function (element) {
        this.handler.listen(element.events, 'changePosition', this.updateAll);
        this.handler.listen(element.events, 'changeSize', this.updateAll);
    };
    Dialog.prototype.listenToLink = function (link) {
        var view = this.props.view;
        var source = view.model.getElement(link.sourceId);
        var target = view.model.getElement(link.targetId);
        this.listenToElement(source);
        this.listenToElement(target);
        this.handler.listen(link.events, 'changeVertices', this.updateAll);
    };
    Dialog.prototype.calculatePositionForElement = function (element) {
        var paperArea = this.props.paperArea;
        var bbox = geometry_1.boundsOf(element);
        var y0 = paperArea.paperToScrollablePaneCoords(bbox.x, bbox.y).y;
        var _a = paperArea.paperToScrollablePaneCoords(bbox.x + bbox.width, bbox.y + bbox.height), x1 = _a.x, y1 = _a.y;
        return {
            x: x1 + ELEMENT_OFFSET,
            y: (y0 + y1) / 2 - (HEIGHT / 2),
        };
    };
    Dialog.prototype.calculatePositionForLink = function (link) {
        var _a = this.props, view = _a.view, paperArea = _a.paperArea;
        var source = view.model.getElement(link.sourceId);
        var target = view.model.getElement(link.targetId);
        if (!source || !target) {
            throw new Error('Source and target are not specified');
        }
        var route = view.getRouting(link.id);
        var verticesDefinedByUser = link.vertices || [];
        var vertices = route ? route.vertices : verticesDefinedByUser;
        var polyline = geometry_1.computePolyline(source, target, vertices);
        var polylineLength = geometry_1.computePolylineLength(polyline);
        var targetPoint = geometry_1.getPointAlongPolyline(polyline, polylineLength);
        var _b = paperArea.paperToScrollablePaneCoords(targetPoint.x, targetPoint.y), x = _b.x, y = _b.y;
        return { y: y + LINK_OFFSET, x: x + LINK_OFFSET };
    };
    Dialog.prototype.calculatePosition = function () {
        var target = this.props.target;
        if (target instanceof elements_1.Element) {
            return this.calculatePositionForElement(target);
        }
        else if (target instanceof elements_1.Link) {
            return this.calculatePositionForLink(target);
        }
        throw new Error('Unknown target type');
    };
    Dialog.prototype.getViewPortScrollablePoints = function () {
        var paperArea = this.props.paperArea;
        var paperAreaMetrix = paperArea.getAreaMetrics();
        var min = paperArea.clientToScrollablePaneCoords(0, 0);
        var max = paperArea.clientToScrollablePaneCoords(paperAreaMetrix.clientWidth, paperAreaMetrix.clientHeight);
        return { min: min, max: max };
    };
    Dialog.prototype.getDialogScrollablePoints = function () {
        var _a = this.calculatePosition(), x = _a.x, y = _a.y;
        var min = {
            x: x - FOCUS_OFFSET,
            y: y - FOCUS_OFFSET,
        };
        var max = {
            x: min.x + WIDTH + FOCUS_OFFSET * 2,
            y: min.y + HEIGHT + FOCUS_OFFSET * 2,
        };
        return { min: min, max: max };
    };
    Dialog.prototype.focusOn = function () {
        var paperArea = this.props.paperArea;
        var _a = this.getViewPortScrollablePoints(), viewPortMin = _a.min, viewPortMax = _a.max;
        var _b = this.getDialogScrollablePoints(), min = _b.min, max = _b.max;
        var xOffset = 0;
        if (min.x < viewPortMin.x) {
            xOffset = min.x - viewPortMin.x;
        }
        else if (max.x > viewPortMax.x) {
            xOffset = max.x - viewPortMax.x;
        }
        var yOffset = 0;
        if (min.y < viewPortMin.y) {
            yOffset = min.y - viewPortMin.y;
        }
        else if (max.y > viewPortMax.y) {
            yOffset = max.y - viewPortMax.y;
        }
        var curScrollableCenter = {
            x: viewPortMin.x + (viewPortMax.x - viewPortMin.x) / 2,
            y: viewPortMin.y + (viewPortMax.y - viewPortMin.y) / 2,
        };
        var newScrollabalCenter = {
            x: curScrollableCenter.x + xOffset,
            y: curScrollableCenter.y + yOffset,
        };
        var paperCenter = paperArea.scrollablePaneToPaperCoords(newScrollabalCenter.x, newScrollabalCenter.y);
        paperArea.centerTo(paperCenter);
    };
    Dialog.prototype.render = function () {
        var _a = this.calculatePosition(), x = _a.x, y = _a.y;
        var style = { top: y, left: x, height: HEIGHT, width: WIDTH };
        return (React.createElement("div", { className: 'ontodia-dialog', style: style }, this.props.children));
    };
    return Dialog;
}(React.Component));
exports.Dialog = Dialog;
